(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-dialog]');
    if (!opener) return;
    const dialog = document.getElementById(opener.dataset.openDialog);
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      const field = dialog.querySelector('input[type="search"]');
      if (field) field.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const gallery = document.querySelector('.s-main-product__gallery');
    if (!gallery || gallery.children.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const scrollable = () => gallery.scrollWidth > gallery.clientWidth + 4;
    let timer = null;
    const advance = () => {
      if (!scrollable()) return;
      const rtl = getComputedStyle(gallery).direction === 'rtl';
      const atEnd = Math.abs(gallery.scrollLeft) + gallery.clientWidth >= gallery.scrollWidth - 4;
      if (atEnd) {
        gallery.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        gallery.scrollBy({ left: rtl ? -gallery.clientWidth : gallery.clientWidth, behavior: 'smooth' });
      }
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => { stop(); if (scrollable()) timer = setInterval(advance, 4500); };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((e) => gallery.addEventListener(e, stop, { passive: true }));
    document.addEventListener('visibilitychange', () => { if (document.hidden) { stop(); } else { start(); } });
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    const host = document.querySelector('[data-recommendations]');
    if (!host || host.querySelector('.s-recommendations__grid')) return;
    const run = () => {
      const { url, sectionId, productId, limit, intent } = host.dataset;
      if (!url || !productId) return;
      fetch(`${url}?section_id=${sectionId}&product_id=${productId}&limit=${limit || 4}&intent=${intent || 'related'}`)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            const style = doc.querySelector('style[data-section-stylesheet]');
            if (style) document.head.appendChild(style);
            host.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {});
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run); else setTimeout(run, 1200);
  })();

  } catch(e) { console.error(e); }
})();
})();
